import React, {Component} from 'react';
import RtOvwItem from './RtOvwItem';
import {compare} from '../../utils';
import {Keys, UIConstants} from "../../model/constants";
import ImmutablePropTypes from 'react-immutable-proptypes';

class RtOvwRetoucher extends Component {
    constructor(props) {
        super(props);
        this.handleOver = this.handleOver.bind(this);
        this.handleOut = this.handleOut.bind(this);
    }

    handleOver(element, item) {
        this.props.handleOver(element, item)
    }

    handleOut(event) {
        this.props.handleOut(event)
    }

    getDisplayClass(base) {
        return base+" "+base+'--'+this.props.displayMode;
    }

    getItems() {
        const displayMode = this.props.displayMode;
        return this.props.items.sort(
            (a, b) => {
                if( !a || !b) {
                    console.error("Non-existing item in: "+this.props.id);
                    return 0;
                }
                const aDate = a.get(Keys.Item.PUBLISH_DATE);
                const bDate = b.get(Keys.Item.PUBLISH_DATE);
                const aScore = a.get(Keys.Item.COMPLETION_SCORE);
                const bScore = b.get(Keys.Item.COMPLETION_SCORE);
                const aId = a.get(Keys.ID);
                const bId = b.get(Keys.ID);
                if (!aDate && !bDate) {
                    return -compare(aScore, bScore).thenCompare(aId, bId).result();
                }
                if (!aDate && bDate) { return 1;}
                if (aDate && !bDate) { return -1;}
                return aDate.isAfter(bDate) ? 1 :
                       (bDate.isAfter(aDate) ? -1 :
                        -compare(aScore, bScore).thenCompare(aId, bId));
            }
        ).map(
            (i) => {
                return (
                    <RtOvwItem key={i.get(Keys.ID)} item={i} handleOver={this.handleOver} displayMode={displayMode}/>
                )
            }
        ).toArray();
    }

    render() {
        const {displayMode, firstName, lastName, items} = this.props;
        const getViewCount = () => items.reduce((acc, item) => acc+item.get(Keys.Item.VIEW_COUNT), 0);
        const getDisplayCount = () => items.reduce((acc, item) => acc+item.get(Keys.Item.DISPLAY_COUNT), 0);
        const getTitle = () => displayMode===UIConstants.RT_OVW_FULL?
                               (`${firstName} ${lastName} (${items.count()} items, ${getViewCount()} views, ${getDisplayCount()} displays)`):
                               (`${firstName} ${lastName}`);
        return (
            <div
                 className={this.getDisplayClass('rt-ovw__retoucher')}>
                <div className={this.getDisplayClass('rt-ovw__header-rotator')}>
                    <div className={this.getDisplayClass("rt-ovw__header")}>
                        <div className={this.getDisplayClass('rt-ovw__title')}>{getTitle()}</div>
                    </div>
                </div>
                <div className="rt-ovw__items">
                    <div className={this.getDisplayClass("rt-ovw__item-list")}>
                        { this.getItems()}
                    </div>
                </div>
            </div>
        )

    }
}
export default RtOvwRetoucher;
RtOvwRetoucher.propTypes = {
    id:React.PropTypes.string.isRequired,
    firstName:React.PropTypes.string.isRequired,
    lastName:React.PropTypes.string.isRequired,
    handleOver:React.PropTypes.func.isRequired,
    displayMode:React.PropTypes.string.isRequired,
    items:ImmutablePropTypes.set.isRequired,

}



// WEBPACK FOOTER //
// ./src/ui/components/RtOvwRetoucher.js